import { Component, ElementRef, Input, OnInit, ViewChild, Output, EventEmitter } from "@angular/core";
import { JobOffer } from "../../api/job-offer/job-offer.types";
import { animate, state, style, transition, trigger } from "@angular/animations";
import { CmsCachedService } from "../../api/cms/cms-cached.service";
import { map, Observable } from "rxjs";
import { CmsNameValue } from "../../api/cms/cms.types";
import { StageUpdateEvent } from "../../api/job-offer/job-offer.types";

@Component({
  selector: "mh-job-offer-matches-offer-view",
  templateUrl: "./job-offer-matches-offer-view.component.html",
  styleUrls: ["./job-offer-matches-offer-view.component.less"],
  animations: [
    trigger("showMore", [
      state(
        "show",
        style({
          height: "*",
        }),
      ),
      state(
        "hide",
        style({
          height: "63px",
        }),
      ),
      transition("show <=> hide", [animate(".7s")]),
    ]),
  ],
})
export class JobOfferMatchesOfferViewComponent implements OnInit {
  @Input() jobOffer!: JobOffer;
  @Output() stageUpdated = new EventEmitter<StageUpdateEvent>();
  @ViewChild("jobOfferDescription") jobOfferDescription?: ElementRef;

  isExpanded = false;
  canExpand = false;

  jobOpportunityStages$: Observable<Array<CmsNameValue>>;

  get stageName() {
    return this.jobOpportunityStages$.pipe(map((stages) => stages.find((s) => s.value === this.jobOffer.stage)?.name));
  }

  constructor(private cmsCachedService: CmsCachedService) {
    this.jobOpportunityStages$ = this.cmsCachedService.getUserDataByName("jo-stage");
  }

  ngOnInit() {
    setTimeout(() => {
      this.checkCanExpand();
    });
  }

  private checkCanExpand() {
    if (this.jobOfferDescription) {
      const contentHeight = this.jobOfferDescription.nativeElement.scrollHeight;
      this.canExpand = contentHeight > 63;
    }
  }

  toggleShowMore() {
    this.isExpanded = !this.isExpanded;
  }

  setJobOpportunityStage(stage: number) {
    this.stageUpdated.emit({ jobOffer: this.jobOffer, stage });
  }

  preventClick(event: Event) {
    event.stopPropagation();
  }
}
